import constants from '$$helpers/constants';
import massChange from '../../components/massChange';
import projectsModel from '$$projectModel';

export default {
  async updateItems({ state, dispatch }, payload) {
    const projectId = projectsModel.getActiveGanttId();
    const tasksToUpdate = await massChange.tasks.prepareUpdate(projectId, state.selectedItems, payload.actions);

    await dispatch('tasksModel/updateTasks', {
      tasks: tasksToUpdate,
      sourceEvent: { type: constants.GANTT_SOURCE_EVENT_TYPES.MASS_CHANGE },
      fromGantt: false,
    }, { root: true });
  },

  async deleteItems({ state, dispatch }, { projectId }) {
    const tasksToDelete = state.selectedItems.map(taskId => ({ id: +taskId, gantt_id: +projectId }));

    await dispatch('tasksModel/deleteTasks', {
      tasks: tasksToDelete,
      sourceEvent: { type: constants.GANTT_SOURCE_EVENT_TYPES.MASS_CHANGE },
      fromGantt: false,
    }, { root: true });
  },
};
